/**
 * Catch-all route for signed-out users who hit a URL with no explicit Route.
 *
 * Business rule: protected app paths (including /settings and /flower-shop)
 * must use the same auth gate as /contacts — store returnTo and redirect to
 * sign-in. Unknown non-public paths render a public 404 (Bug #1386).
 */

import { useLocation } from 'react-router-dom';
import { isProtectedAppPath } from '../constants/protectedAppPaths';
import { PublicNotFoundPage } from '../pages/PublicNotFoundPage';
import { ProtectedRoute } from './ProtectedRoute';

/**
 * Renders sign-in redirect for protected paths; otherwise a marketing 404 page.
 */
export function UnauthenticatedCatchAll() {
  const location = useLocation();

  if (isProtectedAppPath(location.pathname)) {
    // ProtectedRoute stores returnTo and navigates to /auth/signin.
    return (
      <ProtectedRoute>
        <span />
      </ProtectedRoute>
    );
  }

  return <PublicNotFoundPage />;
}
